<template>
  <div class="bg2">
    <!-- <Header title="退款中" background="#ffffff"></Header> -->
    <div class="status">
      <span>等待商家处理</span>
    </div>
    <!-- <div class="address">
      <h5 class="name">我的地址</h5>
      <p class="line"></p>
      <div class="addres flex-center">
        <img src="../../assets/my/add@2x.png" alt="" />
        <div class="addRight">
          <div class="msg flex-center">
            <h5>张小明</h5>
            <span>188 1234 5678</span>
          </div>
          <p>山东省临沂市兰山区柳青街道</p>
        </div>
      </div>
    </div> -->
    <div class="goodsDetial">
      <h5>商品详情</h5>
      <p class="line"></p>
      <div class="list flex-center">
        <img src="../../assets/my/pic@2x (1).png" alt="" />
        <div class="orderMsg">
          <p>女生卫衣连帽拼接款</p>
          <p>4299日元(267.19人民币)</p>
        </div>
      </div>
    </div>
    <div class="feeCar">
      <h5>退款详情</h5>
      <p class="line"></p>
      <ul>
        <li><span>退款原因</span><span>19人民币/单</span></li>
        <li><span>退款金额</span><span>立减20人民币</span></li>
        <li><span>退款编号</span><span>4,250日元(266.46人民币)</span></li>
        <li><span>申请时间</span><span>10g</span></li>
        <li><span>退款时间</span><span>10g</span></li>
      </ul>
    </div>
    <div class="feeCar">
      <h5>失败原因</h5>
      <p class="line"></p>
      <p class="resion">商家拒绝：没有发错</p>
    </div>
    <div class="btns">
      <span>撤销申请</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang='less' scoped>
.bg2 {
  padding-bottom: 100px;
}
.status {
  height: 73px;
  background: #e63a2a;
  color: #ffffff;
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.address {
  margin: 14px 0;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
  border-radius: 12px;
  .name {
    height: 50px;
    line-height: 50px;
    padding-left: 16px;
  }
  .line {
    height: 2px;
    background: linear-gradient(90deg, #fd0212 0%, #ffffff 100%);
    opacity: 0.3;
  }
  .addres {
    height: 100px;
    padding: 0 5px;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .addRight {
    }
  }
  .addRight {
    .msg {
      h5 {
        font-size: 18px;
        margin-right: 10px;
      }
      span {
        color: #919398;
        font-size: 15px;
      }
    }
    p {
      color: #606266;
      font-size: 15px;
      line-height: 30px;
    }
  }
}
.line {
  height: 2px;
  background: linear-gradient(90deg, #fd0212 0%, #ffffff 100%);
  opacity: 0.3;
}
.feeCar {
  margin-top: 15px;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
  border-radius: 12px;
  .resion {
    height: 62px;
    line-height: 62px;
    padding-left: 20px;
    color: #414245;
    font-size: 13px;
  }
  h5 {
    padding-left: 16px;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }
  ul {
    padding: 16px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      font-size: 13px;
    }
    .color {
      span:nth-child(2) {
        color: #9d28b0;
      }
    }
  }
}
.goodsDetial {
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
  border-radius: 12px;
  padding-bottom: 30px;
  h5 {
    height: 50px;
    padding-left: 15px;
    line-height: 50px;
    font-size: 16px;
  }

  .list {
    padding-top: 16px;
    padding-left: 16px;
    img {
      width: 88px;
      height: 82px;
      margin-right: 10px;
    }
    .orderMsg {
      height: 70px;
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      color: #303133;
      font-size: 14px;
      border-bottom: 1px solid #f0f0f0;
      p:nth-child(2) {
        font-size: 13px;
        color: #fd0212;
      }
    }
  }
}
.btns {
  height: 60px;
  display: flex;
  justify-content: flex-end;
  background: #ffffff;
  width: 100%;
  margin-top: 14px;
  padding: 12px 14px 0 0;
  bottom: 0;
  position: fixed;
  span {
    width: 68px;
    height: 26px;
    font-size: 12px;
    text-align: center;
    line-height: 26px;
    background: #e63a2a;
    border-radius: 4px;
    margin-left: 10px;
    color: #ffffff;
  }
}
</style>
